import { render, staticRenderFns } from "./BlockBlogListItemUser.vue?vue&type=template&id=13d8c7a3&scoped=true&"
import script from "./BlockBlogListItemUser.vue?vue&type=script&lang=js&"
export * from "./BlockBlogListItemUser.vue?vue&type=script&lang=js&"
import style0 from "./BlockBlogListItemUser.vue?vue&type=style&index=0&id=13d8c7a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d8c7a3",
  null
  
)

export default component.exports